// extracted by mini-css-extract-plugin
export var content = "index-module--content--8qBSt";
export var decimalList = "index-module--decimalList--jKs8Z";
export var discList = "index-module--discList--YYqwk";
export var sectionTitle = "index-module--sectionTitle--SG-py";